import * as types from '../action-types';

const initialState = {
  book_data: [],
  loading: false,
  place_info: {},
  zone_info: {},
  zone_filters: [],
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case types.GET_BOOK_DATA:
      return { ...state, loading: true };

    case types.GET_BOOK_DATA_SUCCESS:
      return { ...state, book_data: [...payload], loading: false };

    case types.GET_BOOK_DATA_FAILURE:
      return { ...state };

    case types.GET_PLACE_INFO:
      return { ...state };

    case types.GET_PLACE_INFO_SUCCESS:
      return {
        ...state,
        place_info: { ...payload.place_info },
        zone_info: { ...payload.zone_info },
        zone_filters: [...payload.zone_filters],
      };

    case types.GET_PLACE_INFO_FAILURE:
      return { ...state };

    default:
      return { ...state };
  }
};
